<!-- bloc de gauche -->
<ng-container *ngIf="bloc === 'gauche'">
    <div>
        <div class="grid justify-items-center">
            <div class="font-medium mb-5 hidden lg:block text-center text-secondary" translate>
                lingueopro.dashboard.upcoming_sessions.Passage du LILATE
            </div>
            <div class="font-extrabold text-2xl" translate>
                <span translate>lilate.dashboard.waiting</span><br />
                <span translate>lilate.dashboard.planning</span>
            </div>
        </div>
    </div>

    <button (click)="bookLilate(lilate)" [disabled]="isLilateBundleBlocked()"
        class="w-full text-green-100 bg-green-500 mt-10 disabled:opacity-50 disabled:cursor-not-allowed" mat-flat-button translate>
        <span translate>
            lilate-exam.session-content.bootime.pending
        </span>
    </button>
    <p class="text-sm text-amber-700 text-center mt-4" *ngIf="isLilateBundleBlocked()">
        {{ getLilateBundleBlockedMessage() }}
    </p>
    <!-- Réservation possible dès l'inscription : la date de début annonce le premier jour des créneaux -->
    <p class="text-sm text-secondary text-center mt-4" *ngIf="isBeforeEarliestStartDate()">
        <span translate [translateParams]="{ date: earliestStartDateLabel() }">lilate-exam.booking-available-on</span>
    </p>
</ng-container>

<!-- bloc de droite -->
<ng-container *ngIf="bloc === 'droite'">
    <div class="mt-2 leading-relaxed text-gray-700" translate>lilate.dashboard.bookNow</div>
    <div class="mt-4 p-4 rounded-lg border border-amber-200 bg-amber-50 text-amber-900 text-sm"
        *ngIf="isLilateBundleBlocked()">
        {{ getLilateBundleBlockedMessage() }}
    </div>
    <div *ngIf="(lilate.status == 'booked' || lilate.status == 'identity_issue') && !isPendingAssessment">
        <div class="booked-guidance" *ngIf="!providerRequirements" translate>
            <span translate>lilate-exam.session-content.bootime.pending</span>
            </div>
    </div>
    <div class="flex items-center mt-10">
        <div class="font-medium text-secondary" translate>lilate.dashboard.planningSteps</div>
        <div class="flex-auto ml-2 border-b-2"></div>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-y-4 mt-6">
        <div class="flex items-center">
            <mat-icon class="icon-size-5" [ngClass]="{'text-green-600': isStepBirthdateDone }"
                [svgIcon]="'heroicons_solid:badge-check'"></mat-icon>
            <div class="ml-2" [ngClass]="{'line-through': isStepBirthdateDone }" translate>
                lilate.dashboard.verifyIdentity</div>
        </div>
        <div class="flex items-center">
            <mat-icon class="icon-size-5" [ngClass]="{'text-green-600': isStepLevelDone }"
                [svgIcon]="'heroicons_solid:badge-check'"></mat-icon>
            <div class="ml-2" [ngClass]="{'line-through': isStepLevelDone }" translate>lilate.dashboard.indicateLevel
            </div>
        </div>

        <div class="flex items-center">
            <mat-icon class="icon-size-5" [ngClass]="{'text-green-600': isStepBusinessDone }"
                [svgIcon]="'heroicons_solid:badge-check'"></mat-icon>
            <div class="ml-2" [ngClass]="{'line-through': isStepBusinessDone }" translate>
                lilate.dashboard.indicateBusinessSector</div>
        </div>
        <div class="flex items-center">
            <mat-icon class="icon-size-5" [ngClass]="{'text-green-600': isStepPhotoDone }"
                [svgIcon]="'heroicons_solid:badge-check'"></mat-icon>
            <div class="ml-2" [ngClass]="{'line-through': isStepPhotoDone }" translate>
                lilate.dashboard.validatePhotoIdentity</div>
        </div>
        <div class="flex items-center">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:badge-check'"></mat-icon>
            <div class="ml-2" translate>lilate.dashboard.chooseDateTime</div>
        </div>
    </div>
</ng-container>